// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1EH1B","inputDescription":"styles_inputDescription__1Es5b"};